var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.maked_sale && _vm.maked_sale.client)?_c('b-button-group',{staticClass:"btn-pago"},[_c('b-button',{attrs:{"variant":"primary"},on:{"click":_vm.pago}},[_c('i',{staticClass:"icon-dolar"}),_vm._v(" Anotar Pago ")])],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }